<template>
  <SogForm ref="_form">
    <SogFormField>
      <SogTextBox
        v-show="isCreate"
        v-model="_data.id"
        placeholder="Id"
        name="Id"
      />
      <SogTextBox
        v-model="_data.userName"
        placeholder="Benutzername"
        name="User name"
      />
    </SogFormField>
    <SogFormField>
      <SogTextBox
        v-model="_data.description"
        placeholder="Beschreibung"
        name="User name"
      />
    </SogFormField>
    <SogFormField>
      <SogDropDownList
        v-model="_data.mode"
        :placeholder="_data.mode"
        name="Modus"
        :data-source="_modus"
      />
    </SogFormField>
    <SogFormField>
      <SogTextBox
        v-model="_data.communicationPartnerIdentifer"
        placeholder="Kommunikationpartner Id"
        name="Kommunikationpartner Id"
      />
    </SogFormField>
    <SogFormField>
      <SogNumericTextBox
        v-model="_data.pinErrorAllowed"
        placeholder="PIN erlaubte Fehlversuche"
        name="pinErrorAllowed"
        format="N"
      />
    </SogFormField>
    <SogFormField>
      <SogSwitch
        v-model="_data.briefkasten"
        placeholder="Briefkasten"
      />
    </SogFormField>
    <SogFormField>
      <SogTextBox
        v-model="_data.transferBriefkastenIds"
        placeholder="Transferbriefkasten Ids"
      />
    </SogFormField>
  </SogForm>
</template>

<script setup lang="ts">
import SogForm from "@/shared/ui/SogForm.vue";
import GdvAccess from "@/shared/model/GdvAccess";
import {ref, watch} from "vue";
import copyTo from "@/shared/utils/CopyTo";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogSwitch from "@/shared/ui/SogSwitch.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import SogDropDownList from "@/shared/ui/SogDropDownList.vue";
interface Props {
  data?:GdvAccess
  isCreate?:boolean
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _modus = [
  {id:"PP", value:"PP für Produktionsnachrichten"},
  {id:"PT", value:"PT für im Produktionssystem notwendige gemeinsame Tests"},
  {id:"TU", value:"TU für unabhängige Tests"},
  {id:"TG", value:"TG für gemeinsame Tests"},
  {id:"Offline", value:"Offline"},
]
const props = withDefaults(defineProps<Props>(), {
      data:undefined,
      isCreate:false
    }
)
const _data = ref<GdvAccess>(new GdvAccess());
const _form = ref<InstanceType<typeof SogForm>  | null>(null)


watch((props),()=>{
  if (props.data) {
    copyTo(props.data, _data.value)
  }

},{immediate:true})



function validate():boolean{
  return _form.value?.validate()??false;
}

function getResults():GdvAccess{
  const res = new GdvAccess();
  copyTo(_data.value,res)
  return res;
}

defineExpose({
  getResults,validate
})


</script>

<style scoped>

</style>
